export const FLASH_MESSAGE_TRANSLATION_PREFIX = 'flash_messages'
